import { EMPLOYER_NPS_COMPONENT_NAME } from 'components/PayDetails/constants';

import {
  flexibleBenefitsTax80Sections,
  flexibleBenefitsTaxSections,
} from 'components/WizardViews/SalaryComponents/constants';

export const isEmptyOrWhitespace = (value: string | undefined | null): boolean => {
  return !value || value.trim() === '';
};

export const isEmptyArray = (arr: any[] | undefined): boolean => {
  return !arr || arr.length === 0;
};

export const isEmployerNPSComponent = (name: string): boolean => {
  return name === EMPLOYER_NPS_COMPONENT_NAME;
};

export const getFlexibleComponentTaxSectionsDisplayList = ({
  taxExemptionSection,
  isEditFlow,
}: {
  taxExemptionSection?: string;
  isEditFlow: boolean;
}) => {
  if (!isEditFlow) return flexibleBenefitsTaxSections;

  if (!taxExemptionSection) return flexibleBenefitsTaxSections;

  const currentTaxSectionIn80Sections = flexibleBenefitsTax80Sections.find((sections) => {
    return sections.key === taxExemptionSection;
  });

  if (!currentTaxSectionIn80Sections) return flexibleBenefitsTaxSections;

  return [...flexibleBenefitsTaxSections, currentTaxSectionIn80Sections];
};
